import { useParams, Link } from "react-router-dom";
import { dayTours } from "../data/tours";
import "./DayTours.css";

export default function DayTourDetail() {
  const { id } = useParams();
  const tour = dayTours.find((t) => t.id === id);

  if (!tour) return <p className="not-found">Tour not found</p>;

  const whatsappNumber = "255682837935";
  const message = `Hello, I would like to ask for the price and book this tour:\n\n${tour.title}`;
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <section className="tour-detail-card">
      <div className="detail-layout">
        {/* IMAGE */}
        <div className="detail-image-wrapper">
          <img
            src={tour.image}
            alt={tour.title}
            className="detail-image"
          />
        </div>

        {/* TEXT */}
        <div className="detail-text">
          <h2>{tour.title}</h2>
          <p className="location">📍 {tour.location}</p>

          <p className="short-desc">{tour.shortDescription}</p>

          <div className="long-description">
            {tour.longDescription
              .split("\n\n")
              .map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
          </div>

          {/* ACTIONS */}
          <div className="detail-actions">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Ask for Price & Book Tour
            </a>

            <Link to="/day-tours" className="btn-back">
              ← Back to Tours
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
